import { FC } from "react";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { useAccess } from "../../hooks/useAccess";
import { useConfirm } from "../../hooks/useConfirm";
import { useVendor } from "../../hooks/useVendor";
import { IVendor } from "../../model/IVendor";
import { msg } from "../../msg";
import { icons } from "../../icons/IconSet";
import DropMenu from "../common/dropmenu/DropMenu";

const VendorActionMenu: FC<{ vendorId: IVendor['id'], vendorName?: string }> = ({ vendorId, vendorName }) => {
  const confirm = useConfirm();
  const { deleteVendor } = useVendor();
  const navigate = useNavigate();
  const { getSettingAccess } = useAccess();

  // -- Handlers
  const handleDelete = () => {
    // -- Check permissions
    if (!getSettingAccess('delete-vendor')) return navigate('/vendors');

    confirm.on({
      text: `Please confirm that you want to delete this vendor ${vendorName ? `(${vendorName})` : ''}`,
      action: async () => (await deleteVendor(vendorId)) === null && toast.success(msg('vendor-deleted')),
      applyText: 'Delete',
    });
  }

  return (
    <div className="flex items-center">
      <DropMenu
        width="110px"
        top="20px"
        right="6px"
        icon={icons('ellipsis-vertical', { width: '18px' })}
        links={[
          ...(!getSettingAccess('edit-vendor') ? [] : [{
            name: (
              <div className='flex gap-2 items-center'>
                {icons('edit', { width: '16px' })}
                Edit
              </div>),
            onClick: () => navigate(`/vendors/${vendorId}`)
          }]),
          ...(!getSettingAccess('delete-vendor') ? [] : [{
            name: (
              <div className='text-red-500 flex gap-2 items-center'>
                {icons('delete', { width: '16px' })}
                Delete
              </div>),
            onClick: handleDelete
          }]),
        ]}
      />
    </div>
  );
}

export default VendorActionMenu;
